import { v4 as uuidv4 } from "uuid";

export const generateUniqueFileCode = () => {
  const uuid = uuidv4().replace(/-/g, "");
  const shuffled = uuid.split("").sort(() => 0.5 - Math.random());
  const random4 = shuffled.slice(0, 4).join("");
  console.log("Generated UUID:", uuid);
  console.log("Random 4-digit alphanumeric value:", random4);
  return random4;
};
